import Indicador from "..";
// import CMGraficoPainel from "./components/CMGraficoPainel";
// import CMGraficoRelatorio from "./components/CMGraficoRelatorio";
import EditFields from "./components/EditFields";
import { ParamFields } from "./components/ParamFields";
import Report from "./reports";
import ReportSummary from "./reports/summary";

export default class CM extends Indicador {
    static get fullName() {
        return "Consumo de Muda";
    }

    static get abbrev() {
        return "CM";
    }

    static get quantifierMeta() {
        return "Kg"
    }

    static paramFields(tipoIndicadorField = '') {
        return <ParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <EditFields visita={visita} TipoClass={TipoClass} />
    }

    // static getGraficoPainel(mediaAgrupadorList, fullName, nomeAgrupador, meta) {
    //     return <CMGraficoPainel media={mediaAgrupadorList[0].media} fullName={fullName} nomeAgrupador={nomeAgrupador} />
    // }

    // static getGraficoRelatorio(h, mediaAgrupadorList, metaUsar, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro) {
    //     return CMGraficoRelatorio(h, mediaAgrupadorList, metaUsar, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro)
    // }

    async renderReport(visita) {
        return Report(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return ReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        const numColetas = apontamento.coletas.length;
        let sumPeso = 0;

        for (const coleta of apontamento.coletas) {
            if (coleta.peso) {
                sumPeso += f(coleta.peso);
            }
        }

        apontamento.media = sumPeso / numColetas;
        apontamento.media = apontamento.media.toFixed(4);

        // 1000g é 1 kilo
        // const consumoColetado = f(((sumPeso * params.metrosLineares) / params.metrosAvaliados) / 1000)
        const consumoColetado = f(((apontamento.media * params.metrosLineares) / params.metrosAvaliados) / 1000)
        // console.log("((" + apontamento.media + " * " + params.metrosLineares + ") / " + params.metrosAvaliados + ") / 100", consumoColetado)

        // // porcentagem
        // apontamento.conformidade = ((consumoColetado / numColetas) / params.meta) * 100
        // console.log("((" + consumoColetado + " / " + numColetas + ") / " + params.meta + ") * 100", apontamento.conformidade)

        apontamento.acima = consumoColetado > f(params.meta) ? 1 : 0
        apontamento.abaixo = 0

        // return Math.abs(apontamento.conformidade).toFixed(2)
        return Math.abs(consumoColetado).toFixed(2)
    }

    static getConformidadeStatus(conformidade, meta) {
        // return this.calcConformidadeStatusInverte(conformidade, meta, 110, 100, 90);
        return ''
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },
            { title: "Talhão", field: "talhao.nome", width: 30 },
            { title: "Frente", field: "frente", width: 'auto' },
            {
                title: "Operador", width: 'auto', getValue: (a) => {
                    if (a.operador && a.operador.operador) return a.operador.operador
                    if (typeof a.operador === "string" && a.operador) return a.operador
                    return "-"
                }
            },
            {
                title: "Consumo (Kg)", field: "conformidade", width: 60, getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta))
                }
            },
        ]
    }
    static getResultStr(apontamento) {
        return ""
    }
}
